import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M17 19H7C5.89543 19 5 18.1046 5 17V7C5 5.89543 5.89543 5 7 5H17C18.1046 5 19 5.89543 19 7V17C19 18.1046 18.1046 19 17 19ZM7 7V17H17V7H7ZM11 15.362L8.3 12.715L9.7 11.285L11 12.556L14.3 9.289L15.7 10.711L11 15.361V15.362Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "CheckboxChecked"
);
